// Main Fonts
// Dont forget to update app.js with the fonts you need.

export const fonts = {
  extraBold: 'Inter-Bold',
  bold: 'Inter-SemiBold',
  regular: 'Inter-Medium',
};
